/**false
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Injectable, NgModule} from '@angular/core';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
  NbPasswordAuthStrategy,
  NbAuthModule,
  NbAuthJWTToken,
  NbAuthJWTInterceptor,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbDummyAuthStrategy,
  NbAuthResult,
} from '@nebular/auth';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {environment} from '../environments/environment';
import {RestFrameworkHttpErrorInterceptor} from './@core/services/rest-framework-service';
import {AuthGuard} from './@core/security/AuthGuard';
import {NgxEditorModule} from 'ngx-editor';
import {CookieTempService} from './@core/services/cookie.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Injectable()
export class TrueAptBatiAuthStrategy extends NbPasswordAuthStrategy {
}

@Injectable()
export class DummyAptBatiAuthStrategy extends NbDummyAuthStrategy {
}

const AuthStrategy = environment.use_mock
  ? [
    DummyAptBatiAuthStrategy.setup({
      name: 'aptbait',
      alwaysFail: false,
    }),
  ]
  : [
    TrueAptBatiAuthStrategy.setup({
      name: 'aptbait',
      baseEndpoint: '',
      login: {
        endpoint: environment.jwt_create_endpoint,
        method: 'post',
        requireValidToken: true,
      },
      logout: {
        endpoint: environment.jwt_delete_endpoint,
        method: 'delete',
        redirect: {
          success: '/auth/login',
          failure: null,
        },
      },
      token: {
        class: NbAuthJWTToken,
        key: 'access',
      },
      refreshToken: {
        endpoint: environment.jwt_refresh_endpoint,
        method: 'post',
        requireValidToken: true,
        redirect: {
          success: null,
          failure: '/auth/login',
        },
      },
    }),
  ];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEditorModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NbAuthModule.forRoot({
      strategies: AuthStrategy,
      forms: {
        login: {
          strategy: 'aptbait',
        },
        logout: {
          strategy: 'aptbait',
        },
      },
    }),
  ],
  exports: [TranslateModule, ReactiveFormsModule, NgxEditorModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NbAuthJWTInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestFrameworkHttpErrorInterceptor,
      multi: true,
    },
    {
      provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
      useValue: (req) => {
        return (
          req.method !== 'DELETE' &&
          (req.url === environment.jwt_refresh_endpoint ||
            req.url === environment.jwt_create_endpoint)
        );
      },
    },
    AuthGuard,
    CookieTempService,
  ],
})
export class AppModule {
}
